import React from 'react'
import { constants, mixpanel } from 'common/helpers'

import UpgradeSubscriptionFlow from 'components/UpgradeSubscriptionFlow/UpgradeSubscriptionFlow'

import s from './UpgradePlans.scss'


const UpgradePlans = () => (
  <UpgradeSubscriptionFlow
    className={s.upgradePlans}
    placement="thankyou page"
    onFirstClick={() => mixpanel.track(constants.analyticsEvents.upgradePopup, { placement: 'thank you' })}
    dataTestId={constants.testIds.thankYouPage.upgradePlansSection}
  />
)

export default UpgradePlans
